// extracted by mini-css-extract-plugin
export var badgy = "docs-sidemenu--badgy--bc814";
export var clickable = "docs-sidemenu--clickable--ca547";
export var containsCurrent = "docs-sidemenu--contains-current--1e875";
export var current = "docs-sidemenu--current--f3d60";
export var deprecatedBadge = "docs-sidemenu--deprecated-badge--843e7";
export var expander = "docs-sidemenu--expander--c9a8a";
export var expanderList = "docs-sidemenu--expander-list--82280";
export var fixerGuy = "docs-sidemenu--fixer-guy--af76d";
export var hidden = "docs-sidemenu--hidden--ff9c7";
export var labBadge = "docs-sidemenu--lab-badge--b84dd";
export var level1 = "docs-sidemenu--level1--622cd";
export var level2 = "docs-sidemenu--level2--e54fa";
export var level3 = "docs-sidemenu--level3--b9895";
export var menuItem = "docs-sidemenu--menu-item--7a3f3";
export var menuItemBadgeContainer = "docs-sidemenu--menu-item-badge-container--fa7b4";
export var nav = "docs-sidemenu--nav--4f1cd";
export var navToggle = "docs-sidemenu--nav-toggle--d0bec";
export var searchContainer = "docs-sidemenu--search-container--6178a";
export var shown = "docs-sidemenu--shown--92f80";
export var splitter = "docs-sidemenu--splitter--432d0";
export var topGuy = "docs-sidemenu--top-guy--56dc7";
export var versionBadge = "docs-sidemenu--version-badge--12c65";
export var versionBadgeContainer = "docs-sidemenu--version-badge-container--2192e";